"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  breakpoints: {
    keys: ['md', 'lg'],
    values: {
      md: 1024,
      lg: 1440
    }
  },
  direction: 'ltr',
  spaces: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    7: 28
  },
  palette: {
    common: {
      black: '#000',
      white: '#fff'
    },
    base: {
      c00: '#F6F7F9',
      c01: '#BFC9DA',
      c02: '#8092AD',
      c03: '#8092AD',
      c04: '#8092AD',
      c05: '#4C5A70'
    },
    primary: {
      c00: '#E7EEFD',
      // Disabled Background //Blue 000
      c01: '#B7CFFF',
      // Disabled Font //Blue 100
      c03: '#0A51EB',
      // Switch On Background
      c02: '#1D61F6',
      // Background // Blue 200
      c04: '#0A51EB',
      // Hover Background // Blue 300
      c05: '#E7EEFD' // Banner Background

    },
    buttonColor: {
      c00: '#E0E4E9',
      // Disabled Background //Blue 000
      c01: '#8092AD',
      // Disabled Font //Blue 100
      c03: '#0A51EB',
      // Switch On Background
      c02: '#1D61F6',
      // Background // Blue 200
      c04: '#0A51EB',
      // Hover Background // Blue 300
      c05: '#E7EEFD' // Banner Background

    },
    secondary: {
      c00: '#FFC3E2',
      c01: '#FF82BE',
      c02: '#FF419B',
      c03: '#FF0077',
      c04: '#CC005F',
      c05: '#FFEBF5'
    },
    text: {
      c00: '#E7EEFD',
      c01: '#4C5A70',
      c02: '#4C5A70',
      c03: '#081B2D',
      c04: '#081B2D',
      c05: '#BFC9DA'
    },
    background: {
      c00: '#FFFFFF',
      c01: '#F6F7F9',
      c02: '#EDEFF3',
      c03: '#BFC9DA',
      tertiary: '#F8F8F8'
    },
    info: {
      c00: '#F6F7F9',
      // Disabled Background //Blue 000
      c01: '#F6F7F9',
      // Disabled Font //Blue 100
      c02: '#4C5A70',
      // Background // Blue 200
      c03: '#E0E4E9',
      // Switch On Background
      c04: '#E0E4E9',
      // Hover Background // Blue 300
      c05: '#F6F7F9' // Banner Background

    },
    warning: {
      c00: '#FFF5EE',
      c01: '#FDF1E6',
      c02: '#ED7B30',
      c03: '#BF6325',
      c04: '#FFF5EE',
      c05: '#FFF5EE'
    },
    success: {
      c00: '#F0FFF9',
      c01: '#D2FDED',
      c02: '#4EAE8A',
      c03: '#69E4B4',
      c04: '#4EAE8A',
      c05: '#F0FFF9'
    },
    error: {
      c00: '#FAE8E8',
      c01: '#FACDCD',
      c02: '#FA5050',
      c03: '#CC4141',
      c04: '#FFE6E6',
      c05: '#FFEBEB'
    },
    dark: {
      c000: '#BFC9DA',
      c100: '#8092AD',
      c200: '#4C5A70',
      c300: '#081B2D'
    },
    light: {
      c000: '#FFFFFF',
      c100: '#F6F7F9',
      c200: '#EDEFF3',
      c300: '#E0E4E9'
    },
    orange: {
      c000: '#FFF5EE',
      c100: '#FDF1E6',
      c200: '#ED7B30',
      c300: '#BF6325'
    },
    green: {
      c000: '#F0FFF9',
      c100: '#D2FDED',
      c200: '#69E4B4',
      c300: '#4EAE8A',
      c400: '#4EAE8A'
    },
    yellow: {
      c000: '#F9F4E7',
      c100: '#FCEFD0',
      c200: '#F9D277',
      c300: '#F6BB47'
    },
    red: {
      c000: '#FAE8E8',
      c100: '#FACDCD',
      c200: '#FA5050',
      c300: '#CC4141'
    }
  },
  shadows: {
    0: 'none',
    1: '0px 2px 4px rgb(79 81 110 / 30%)',
    2: '0px 0px 10px rgba(0, 0, 0, 0.08);',
    3: 'inset 0px 0px 10px rgba(0, 0, 0, 0.08);',
    10: '0px 0px 4px rgba(54, 42, 102, 0.16);',
    20: '0px 8px 20px 1px rgba(54, 42, 102, 0.1);'
  },
  typography: {
    baseFontSize: 16,
    baseFontFamily: 'Inter',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    fontFamily: {
      regular: {
        fontWeight: 400
      },
      medium: {
        fontWeight: 500
      },
      semibold: {
        fontWeight: 500
      }
    },
    title: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '28px'
    },
    description: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '28px'
    },
    h1: {
      fontSize: '27px',
      lineHeight: '36px',
      letterSpacing: '0.25px',
      margin: '0px',
      fontWeight: 600
    },
    h2: {
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '0.25px',
      margin: '0px',
      fontWeight: 600
    },
    h3: {
      fontSize: '18px',
      lineHeight: '27px',
      letterSpacing: '0.25px',
      margin: '0px',
      fontWeight: 500
    },
    body: {
      fontSize: '16px',
      letterSpacing: '0.25px',
      lineHeight: '24px',
      fontStyle: 'normal',
      fontWeight: 400
    },
    bodyLight: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.25px',
      fontWeight: 400
    },
    bodySmall: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.25px',
      fontWeight: 400
    },
    bodySemiBold: {
      fontSize: '18px',
      lineHeight: '27px',
      letterSpacing: '0.25px',
      fontWeight: 400
    },
    label: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.25px',
      fontWeight: 500
    },
    placeholder: {
      fontSize: '16px',
      letterSpacing: '0.25px',
      lineHeight: '24px',
      fontStyle: 'normal',
      fontWeight: 400,
      color: '#8092AD'
    },
    buttonText: {
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '0.25px',
      fontWeight: 500
    },
    helperText: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.25px',
      fontWeight: 400
    },
    captionText: {
      fontSize: '14px',
      lineHeight: '20px',
      textTransform: 'uppercase',
      letterSpacing: '0.25px',
      fontWeight: 400
    },
    displayText: {
      fontSize: '34px',
      lineHeight: '48px',
      letterSpacing: '0.25px',
      fontWeight: 600
    }
  },
  borderRadius: {
    primary: 8,
    secondary: 24,
    tertiary: 4
  },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
    },
    duration: {
      shortest: 150,
      shorter: 200,
      "short": 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195
    }
  },
  zIndex: {
    context: 800,
    hoverOver: 1000,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    popover: 1000,
    tooltip: 1500,
    rail: 1600
  }
};
exports["default"] = _default;